import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import districtRepository from '../../repositories/master-data/districtRepository';

const dataDistrict = {
  name: null,
};

export const useDistrictStore = defineStore('districtStore', {
  state: () => ({
    componentKey: 0,
    isSuccess: false,
    hasErrorSingle: null,
    // list page
    perpage: 20,
    search: null,
    page: 1,
    listData: [],
    pagination: {},
    isLoadingTable: false,
    // form page
    formData: structuredClone(dataDistrict),
    hasFormError: structuredClone(dataDistrict),
    isLoadingForm: false,
  }),
  actions: {
    async getData() {
      try {
        this.isLoadingTable = true;
        this.hasErrorSingle = null;
        this.isSuccess = false;

        const params = {
          search: this.search,
          page: this.page,
          perpage: this.perpage,
        };
        const dataDistrict = await districtRepository.getData(params);
        if (dataDistrict.data.status === 200) {
          this.listData = dataDistrict.data.data.district.list;
          this.pagination = dataDistrict.data.data.district.pagination;
          this.isLoadingTable = false;
          this.componentKey++;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isLoadingTable = false;
        this.isSuccess = false;
      }
    },
    async searchData() {
      this.page = 1;
      await this.getData();
    },
    async getDataByPaging() {
      await this.getData();
    },
    async saveData() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const saveDistrict = await districtRepository.saveData(params);
        if (saveDistrict.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async getDataDetail(id) {
      this.isSuccess = false;

      const params = {
        district_id: id,
      };
      const dataDetailDistrict = await districtRepository.getDataDetail(params);

      if (dataDetailDistrict.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailDistrict.data.data;
        this.formData = {
          name: data.name,
        };
      }
    },
    async updateData(id) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const params = {
          district_id: id,
          ...this.formData,
        };
        const updateDistrict = await districtRepository.updateData(params);
        if (updateDistrict.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async deleteData(id) {
      try {
        this.isSuccess = false;

        const params = {
          district_id: id,
        };
        const deleteDistrict = await districtRepository.deleteData(params);
        if (deleteDistrict.data.status === 200) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataDistrict);
      }
      this.hasFormError = structuredClone(dataDistrict);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useDistrictStore, import.meta.webpackHot));
}
